module.exports = __webpack_public_path__ + "static/media/Buildings.49bb4b5b.svg";